import Config from 'config';
import AbstractService from './AbstractService';

export default class ReleasesService extends AbstractService {
  static search({ filter, section, pagesize, genres, markets }, options = {}) {
    const { useAISearch = true } = options

    const params = {
      filter,
      section,
      pagesize,
      genres,
      markets
    }

    const endpoint = useAISearch
      ? Config.endpoints.aiSearch
      : Config.endpoints.search

    return this.get(endpoint, params)
  }
}
